import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasAiApi } from '~/services/kyClient';

import { log } from '~/utils';

/**
 * Downloads a file used for AI labeling or model evaluation from Azure Blob Storage.
 * @param blobInfoEncoded - The encoded blob info of the file to download.
 * @param options - Request options.
 * @returns The file.
 * @see https://fa-vestigas-dev.azurewebsites.net/docs#/Metadata/download_file_direct_download_file_direct__blob_info_encoded__get
 */
export const downloadAiFile = async (
  blobInfoEncoded: string | undefined,
  options?: KyRequestOptions,
) => {
  if (!blobInfoEncoded) {
    return undefined;
  }

  try {
    const response = await vestigasAiApi
      .get(ENDPOINT.AI.DOWNLOAD_FILE(), {
        searchParams: {
          blobInfoEncoded,
        },
        ...options,
      })
      .blob();

    return response;
  } catch (error) {
    log.error({
      message: 'Error downloading AI file',
      error,
    });

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
